import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { map, tap } from 'rxjs/operators'
import { ToastrService } from 'ngx-toastr'
import { PieceJointeResponse } from './dto/piece-jointe-response'
import { PieceJointe } from '../../models/piece-jointe'
import { environment } from '../../../../environments/environment'
import {  throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service'
import { OAuthService } from 'angular-oauth2-oidc'


export interface UploadPieceJointeAwsDto {
  filename: string
  url: {
    url: string
    fields: {
      key: string
      'x-amz-algorithm': string
      'x-amz-credential': string
      'x-amz-date': string
      'x-amz-security-token': string
      policy: string
      'x-amz-signature': string
    }
  }
}

interface DownloadPieceJointeAwsDto {
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class PieceJointeService {
  constructor(private http: HttpClient,
              private toastr: ToastrService,
              private oAuthService: OAuthService) {}
  
  private awsBaseUrl = environment.baseUrl;

  uploadPieceJointeAndReturnDownloadUrl(file: File, nomCourbeCharge: string): Observable<string> {
    const sToken = `Bearer ${this.oAuthService.getIdToken()}`;

    return this.getUploadUrl(nomCourbeCharge || file.name, sToken).pipe(
      switchMap((uploadDto: UploadPieceJointeAwsDto) =>
        this.uploadToS3(uploadDto, file).pipe(
          map(() => uploadDto.filename)
        )
      ),
      catchError(error => {
        this.toastr.error(`Erreur lors de l'upload du fichier : ${error.message || error}`);
        return throwError(() => new Error('Failed to upload file'));
      })
    );
  }

  private getUploadUrl(filename: string, sToken: string): Observable<UploadPieceJointeAwsDto> {
    const headers = new HttpHeaders({
      Authorization: sToken,
      'Content-Type': 'application/json'
    });

    const url = `${this.awsBaseUrl}/pieceJointe/${encodeURIComponent(filename)}`;
    console.log('Requesting upload URL:', url);
    return this.http.get<UploadPieceJointeAwsDto>(url, { headers }).pipe(
      tap(response => console.log('Upload URL response:', response)),
      catchError(error => {
        this.toastr.error(`Erreur lors de la récupération de l'URL d'upload : ${error.message || error}`);
        return throwError(() => new Error('Failed to get upload URL'));
      })
    );
  }

  private uploadToS3(uploadDto: UploadPieceJointeAwsDto, file: File): Observable<void> {
    const formData = new FormData();
    formData.append('key', uploadDto.url.fields.key);
    formData.append('x-amz-algorithm', uploadDto.url.fields['x-amz-algorithm']);
    formData.append('x-amz-credential', uploadDto.url.fields['x-amz-credential']);
    formData.append('x-amz-date', uploadDto.url.fields['x-amz-date']);
    if (uploadDto.url.fields['x-amz-security-token']) {
      formData.append('x-amz-security-token', uploadDto.url.fields['x-amz-security-token']);
    }
    formData.append('policy', uploadDto.url.fields.policy);
    formData.append('x-amz-signature', uploadDto.url.fields['x-amz-signature']);
    formData.append('file', file);

    return this.http.post<void>(uploadDto.url.url, formData).pipe(
      tap(() => console.log('S3 upload response: Success')),
      catchError(error => {
        console.error('Error uploading to S3:', error);
        this.toastr.error(`Erreur lors de l'upload vers S3 : ${error.message || error}`);
        return throwError(() => new Error('Failed to upload file to S3'));
      })
    );
  }
  // uploadPieceJointe(pieceJointe: File): Observable<PieceJointeResponse> {
    // DEV-REC-PROD
    //const lambdaUploadPath = `${environment.baseUrl}/media/signed-url/generate/upload?filename=` + pieceJointe.name + `&application=` + `${environment.awsLambdaParam}`

    //let formParams = new FormData();
    //formParams.append('file', pieceJointe)
  //   return null; //this.http.post<PieceJointeResponse>(lambdaUploadPath, formParams)
  // }

  getGooglePickerFileFromUrl(oauthAccessToken: string, googlePickerFileUrl: string, googlePickerFileName: string): Observable<File> {
    console.log('[getGooglePickerFileFromUrl] URL >> Fichier ')
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + oauthAccessToken
    })

    return this.http.get(googlePickerFileUrl, { headers: headers, responseType: 'blob' }).pipe(
      map(blob => {
        let googlePickerFile = new File([blob], googlePickerFileName, { type: blob.type })
        this.toastr.success('[Google Picker] Fichier Téléchargé : '+ googlePickerFileName)
        console.log('[getGooglePickerFileFromUrl] URL >> Fichier = ' + googlePickerFileName)
        return googlePickerFile;
      })
    );
  }

  downloadPieceJointe(chantierCode: string, materielId: number, pieceJointeId: number) : Observable<PieceJointe> {
    const path = `${environment.baseUrl}/chantiers/${chantierCode}/materiels/${materielId}/piecesJointes/download/${pieceJointeId}`
    return this.http.get<PieceJointe>(path)
  }

}
